import { useTranslations } from 'next-intl'

import { Notice } from '@/shared/ui'

export const PaymentNotice = () => {
  const t = useTranslations('card_payment')

  return (
    <div className="px-6">
      <Notice.Title />
      <Notice.List>
        <Notice.Item>{t('notice.corporate_card_issue')}</Notice.Item>
      </Notice.List>
    </div>
  )
}
